module.exports = __webpack_public_path__ + "img/dcmm_23.ab5b3c7f.png";